// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__11z6A","left":"StickyBox_left__1HEE3","right":"StickyBox_right__2Vor7"};